import { Menu } from 'lucide-react';
import Colors from 'shared/styles/colors';

type Props = {
  toggleMobileMenu: () => void;
};

const BurgerMenuButton = ({ toggleMobileMenu }: Props) => {
  return (
    <button
      className="burger-button"
      onClick={toggleMobileMenu}
      aria-label="Toggle menu"
    >
      <Menu color={Colors.white} />
    </button>
  );
};

export default BurgerMenuButton;
